import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { 
  faHome, 
  faCalendarDays,
  faGear,
  faIdCard,
  faRightToBracket,
  faRightFromBracket,
  faXmark,
  faApartment,
  faCircleQuestion
} from '@fortawesome/pro-solid-svg-icons';
import { MobileMenuService } from '../../shared/services/mobile-menu';
import { AuthStoreService } from '../../core/services/auth-store.service';

@Component({
  selector: 'app-mobile-menu',
  standalone: true,
  imports: [CommonModule, RouterModule, FontAwesomeModule],
  templateUrl: './mobile-menu.html',
  styleUrl: './mobile-menu.scss',
})
export class MobileMenuComponent {
  private mobileMenuService = inject(MobileMenuService);
  protected readonly authStore = inject(AuthStoreService);
  
  isOpen = this.mobileMenuService.isOpen;

  faHome = faHome;
  faBuilding = faApartment;
  faCalendarDays = faCalendarDays;
  faGear = faGear;
  faIdCard = faIdCard;
  faRightToBracket = faRightToBracket;
  faRightFromBracket = faRightFromBracket;
  faXmark = faXmark;
  faCircleQuestion = faCircleQuestion;

  protected get userProfileRoute(): string {
    const roles = this.authStore.user()?.type ?? [];

    if (roles.includes('SUPERADMIN') || roles.includes('ADMIN') || roles.includes('MANAGER')) {
      return '/admin/profile';
    }

    return '/perfil';
  }

  close(): void {
    this.mobileMenuService.close();
  }

  logout(): void {
    this.close();
    this.authStore.logout();
  }
}
